
import ImgListSvg from '@/components/svg/SvgImgList.vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ViewGallerySwiper from './swiper/ViewGallerySwiper.vue';

@Component({
  components: {
    ImgListSvg,
    ViewGallerySwiper,
  }
})
export default class extends Vue {
  @Prop() showMoveViewGallery!: boolean;
  
  @Watch('showSwiper')
  watchSwiperState(show: boolean) {
    if (show) {
      document.body.style.overflowY = 'hidden';
    } else {
      document.body.style.overflowY = 'scroll';
    }
  }

  showSwiper = false;

  handleClickImgList() {
    this.showSwiper = true;
  }
  hideSwiper() {
    this.showSwiper = false;
  }
}
